import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Button } from '@sunwebgroup/ui-components/uds'
import cn from 'classnames'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { PublicationCodes } from '@/scopes/common/domain/models'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useDestinationTitleValues } from '@/scopes/destinations/components/useDestinationTitleValues'
import styles from './SearchButton.module.css'

interface SearchButtonProps {
  hiddenOnMobile?: boolean
}

export function SearchButton({ hiddenOnMobile = false }: SearchButtonProps) {
  const intl = useIntl()
  const searchLink = useCMSPageField('DestinationPage.searchLink')
  const publicationCode = useConfiguration('publicationCode')
  const season = PublicationCodes.isSunwebWinterPublicationCode(publicationCode) ? 'winter' : 'summer'
  const { destinationName, preposition } = useDestinationTitleValues({ shouldUseSpecialPreposition: true })

  const buttonTranslationKeyBySeason = {
    winter: 'destination_search_button_text__winter',
    summer: 'destination_search_button_text__summer',
  }

  if (!searchLink) {
    return null
  }

  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.hiddenOnMobile]: hiddenOnMobile,
    },
  )

  return (
    <div className={wrapperClassName}>
      <Button forwardedAs="a" href={searchLink}>
        <Icon glyph="Magnifier" />
        {intl.formatMessage(
          { id: buttonTranslationKeyBySeason[season] },
          { preposition, destinationName },
        )}
      </Button>
    </div>
  )
}
